import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getConfig = async () => (await axios.get(`${API}/config`)).data;

export const createQuote = async (payload) =>
  (await axios.post(`${API}/quotes`, payload)).data;

export const updateQuote = async (id, payload) =>
  (await axios.patch(`${API}/quotes/${id}`, payload)).data;

export const buildWhatsAppUrl = (number, quote, extraLines = []) => {
  const lines = ["Hola PuntoCell 👋"];
  const cyclesLine = quote.charge_cycles != null ? [`🔄 Ciclos de carga: ${quote.charge_cycles}`] : [];
  const simLine = quote.sim_type ? [`📶 Tipo de SIM: ${quote.sim_type}`] : [];

  if (quote.requires_evaluation) {
    lines.push(
      "Quiero coordinar una evaluación técnica.",
      "",
      `📱 Equipo: ${quote.model} ${quote.capacity}`,
      ...(quote.color ? [`🎨 Color: ${quote.color}`] : []),
      `🔋 Batería: ${quote.battery_percent}%`,
      ...cyclesLine,
      ...simLine,
      `⚠️ ${(quote.problem_labels && quote.problem_labels.length > 1) ? "Daños" : "Daño"}: ${quote.problem_label}`,
      `🆔 Cotización: ${quote.id}`,
      "",
      "Por el tipo de daño indicado, el equipo requiere evaluación técnica."
    );
  } else if (quote.price_available === false) {
    lines.push(
      "Quiero consultar el precio de Trade-In de mi equipo.",
      "",
      `📱 Equipo: ${quote.model} ${quote.capacity}`,
      ...(quote.color ? [`🎨 Color: ${quote.color}`] : []),
      `🔋 Batería: ${quote.battery_percent}%`,
      ...cyclesLine,
      ...simLine,
      `🆔 Cotización: ${quote.id}`,
      "",
      "Aún no aparece el precio publicado para este equipo, ¿me lo pueden indicar?"
    );
  } else {
    const intentHeader = quote.operation === "cash"
      ? "💰 QUIERO VENDER MI IPHONE POR EFECTIVO"
      : "🔄 QUIERO CAMBIAR MI IPHONE POR OTRO";
    const valueLine = quote.operation === "cash"
      ? `💵 Valor estimado de compra en efectivo: $${Number(quote.cash_price).toFixed(0)}`
      : `💰 Valor estimado de Trade-In: $${Number(quote.price).toFixed(0)}`;
    lines.push(
      intentHeader,
      "",
      `📱 Equipo: ${quote.model} ${quote.capacity}`,
      ...(quote.color ? [`🎨 Color: ${quote.color}`] : []),
      `🔋 Batería: ${quote.battery_percent}%`,
      ...cyclesLine,
      `📋 Condición: ${quote.aesthetic_label}`,
      `📦 Caja original: ${quote.has_box ? "Sí" : "No"}`,
      ...simLine,
      valueLine,
      `🆔 Cotización: ${quote.id}`,
      "",
      "Entiendo que el valor es una estimación y está sujeto a revisión física del equipo."
    );
  }

  if (extraLines && extraLines.length) { lines.push("", ...extraLines); }
  const text = encodeURIComponent(lines.join("\n"));
  const base = number ? `https://wa.me/${number}` : `https://wa.me/`;
  return `${base}?text=${text}`;
};
